/** Returns the first letter of a display name, used as a fallback avatar initial. */
export const getLetterUser = (nom_usage: string): string => {
  return nom_usage.substring(0, 1);
};
